/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DataChartTrendXyUpIcon16Light } from './DataChartTrendXyUpIcon16Light';
import { DataChartTrendXyUpIcon16Regular } from './DataChartTrendXyUpIcon16Regular';
import { DataChartTrendXyUpIcon16Solid } from './DataChartTrendXyUpIcon16Solid';
import { DataChartTrendXyUpIcon20Light } from './DataChartTrendXyUpIcon20Light';
import { DataChartTrendXyUpIcon20Regular } from './DataChartTrendXyUpIcon20Regular';
import { DataChartTrendXyUpIcon20Solid } from './DataChartTrendXyUpIcon20Solid';
import { DataChartTrendXyUpIcon24Regular } from './DataChartTrendXyUpIcon24Regular';
import { DataChartTrendXyUpIcon24Solid } from './DataChartTrendXyUpIcon24Solid';
import { DataChartTrendXyUpIcon32Regular } from './DataChartTrendXyUpIcon32Regular';
import { DataChartTrendXyUpIcon64Regular } from './DataChartTrendXyUpIcon64Regular';
var sizes = {
    16: {
        light: DataChartTrendXyUpIcon16Light,
        regular: DataChartTrendXyUpIcon16Regular,
        solid: DataChartTrendXyUpIcon16Solid,
    },
    20: {
        light: DataChartTrendXyUpIcon20Light,
        regular: DataChartTrendXyUpIcon20Regular,
        solid: DataChartTrendXyUpIcon20Solid,
    },
    24: {
        regular: DataChartTrendXyUpIcon24Regular,
        solid: DataChartTrendXyUpIcon24Solid,
    },
    32: {
        regular: DataChartTrendXyUpIcon32Regular,
    },
    64: {
        regular: DataChartTrendXyUpIcon64Regular,
    },
};
export var DataChartTrendXyUpIcon = forwardRef('DataChartTrendXyUpIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
